// src/components/ThemeToggle.jsx
// Sliding pill toggle: a track holding both sun + moon, with a knob that slides
// to the active side. The knob shows the current mode; faded icons sit behind.

import React from "react";
import { Sun, Moon } from "./icons";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { isDarkMode, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      role="switch"
      aria-checked={isDarkMode}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={isDarkMode ? "Light mode" : "Dark mode"}
      className={`relative inline-flex items-center h-9 w-[68px] rounded-full p-1
                  border border-tb-border dark:border-tb-d-border
                  bg-tb-bg-2 dark:bg-tb-d-inset
                  transition-colors duration-300 group ${className}`}
    >
      {/* faded background icons on each side */}
      <span className="absolute inset-0 flex items-center justify-between px-2 pointer-events-none">
        <Sun size={15} className={`transition-opacity duration-300 ${isDarkMode ? "opacity-30 text-tb-muted" : "opacity-0"}`} />
        <Moon size={15} className={`transition-opacity duration-300 ${isDarkMode ? "opacity-0" : "opacity-30 text-tb-muted"}`} />
      </span>

      {/* sliding knob carrying the active icon */}
      <span
        className={`relative z-10 grid place-items-center h-7 w-7 rounded-full
                    bg-white dark:bg-tb-d-card shadow-md
                    transition-transform duration-300 ease-out
                    ${isDarkMode ? "translate-x-[32px]" : "translate-x-0"}`}
      >
        <Sun
          size={16}
          className={`col-start-1 row-start-1 text-amber-500 transition-all duration-300
                      ${isDarkMode ? "opacity-0 -rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"}`}
        />
        <Moon
          size={16}
          className={`col-start-1 row-start-1 text-indigo-400 transition-all duration-300
                      ${isDarkMode ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-50"}`}
        />
      </span>
    </button>
  );
}